export const name = 'TemplateDeleteController';
export default function TemplateDeleteController($mdDialog, $log, templatesService, errorDialogOpen, analyticsFactory, $translate) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var vm = this;

  vm.cancel = cancel;
  vm.deleteTemplates = deleteTemplates;
  vm.isInProgress = false;
  vm.numOfTemplatesToDelete = vm.templatesIds.length;

  $translate.onReady(function() {
    vm.confirmDeletionTranslation = $translate.instant('imposer.composer-main.Templates_DeleteConfirm').replace('{0}', vm.numOfTemplatesToDelete);
  });

  function cancel(data) {
    var functionName='TemplateDeleteController.cancel';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    $mdDialog.cancel();

    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }

  function deleteTemplates() {
    var functionName='TemplateDeleteController.deletetemplate';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    vm.isInProgress = true;

    templatesService.deleteMultipleTemplates(vm.templatesIds).then(function () {
      $log.info(angular.toJson({action:'templates deleted successfully', functionName:functionName}));
      analyticsFactory.eventTrack(analyticsFactory.actions.templateDeletion, analyticsFactory.categories.composer, analyticsFactory.labels.success, null);
      $mdDialog.hide();
    }, function(status) {
      errorDialogOpen.openErrorDialog(status);
      $log.info(angular.toJson({action:'error deleting template', functionName:functionName}));
      analyticsFactory.eventTrack(analyticsFactory.actions.templateDeletion, analyticsFactory.categories.composer, analyticsFactory.labels.failure, null);
      $mdDialog.hide();
    });

    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }
}
